var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.address.flag == 1)?_c('Contract',{attrs:{"contract":_vm.address,"isLoading":_vm.isLoading}}):_c('Account',{attrs:{"account":_vm.address,"isLoading":_vm.isLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }